import { ICaregiverConsultationDto } from '@/caregiverSpace/shared/model';

export const selectConsultations =
    (shouldShowMyConsultationsOnTop: boolean) =>
    (userId: number) =>
    (consultations: ICaregiverConsultationDto[]) => {
        if (!shouldShowMyConsultationsOnTop) {
            return consultations;
        }

        // Move consultations assigned to current user to the top; keep others order
        return [...consultations].sort((a, b) => {
            const aIsMine = a?.AssignedCaregiver?.UserId === userId ? 1 : 0;
            const bIsMine = b?.AssignedCaregiver?.UserId === userId ? 1 : 0;
            return bIsMine - aIsMine;
        });
    };
